import axios from '../axios'

/*
 * 日志管理模块
 */

// 查询
export const view = (data) => {
    return axios({
        url: '/sysLog/view',
        method: 'post',
        data
    })
}

export const list = (data) => {
  return axios({
    url: '/sysLog/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/log.js